import { datadogRum } from '@datadog/browser-rum'
import config from '../config/config'

export const initDatadog = () => {
	if ( config.DATADOG_APP_ID && config.DATADOG_APP_TOKEN && [ 'prod', 'stage' ].includes( config.DATADOG_ENV ) ) {
		datadogRum.init( {
			applicationId: config.DATADOG_APP_ID,
			clientToken: config.DATADOG_APP_TOKEN,
			site: 'datadoghq.com',
			service: 'inventory-web',
			env: config.DATADOG_ENV,
			// needed for the HTTP 5xx monitor to have trace data
			allowedTracingUrls: [ config.API_URL ],
			traceSampleRate: 100,
			sessionSampleRate: 100,
			sessionReplaySampleRate: 20,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: 'allow',
		} )
	}
}
